import React  from 'react';
import {useSelector} from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { Row } from "react-bootstrap";
import useMessage from '../hooks/useMessage';
// import PreEcho from '../components/PreEcho';
import SideBar from '../components/chats/SideBar';
import ChatInput from '../components/chats/ChatInput';
import MessageList from '../components/chats/MessageList';
import MessageHeader from '../components/chats/MesssageHeader';
import RenderTask from '../components/tasks/RenderTask'; //components/actions 

import useMediaQuery from '../hooks/useMediaQuery';
import useFlashFavicon from '../hooks/useFlashFavicon';
// import TaskTable from '../tables/TaskTable';

//manage=> service  
const Admin = ()=>{


    const [hide,setHide] = React.useState(false);

    const isMobile = useMediaQuery('(max-width: 768px)');

   
    //toggle the view
    const toggleView = ()=>{
          setHide(!hide);
    }
 
    const {userInfo} = useSelector(state=>state.userLogin);

    const navigate   = useNavigate();

    useFlashFavicon();

    React.useEffect(()=>{
        if(!['STAFF','AGENT'].includes(userInfo?.role_type))
        {
             navigate('/login');
        }

    },[userInfo]);
     
    const {isProxy,error,disable,activePID,allPID,clickPID,inputKeyUp,getMessages,submitHandler,testHandler} = useMessage();
    //init
    const data =  getMessages();

    let messages = data
            .sort((a,b)=> b.timestamp - a.timestamp)
            .filter(m=>m.from !== m.to).slice(0,20);
    


    return (
      <>
      {
         isMobile ? (<div className ='row text-center'>
            <p className='mx-auto mt-3 text-danger' style = {{fontSize:'125%'}}>暂不支持手机版本</p>
        </div>) :(
            
             <Row style = {{borderBottom:'1px solid #e2e2e2',borderTop:'1px solid #e2e2e2'}} className ='mt-3 rounded shadow adminBox'>
        <div className ='col-md-2 col-xs-12 p-2 text-danger' style={{height:'88vh',borderLeft:'1px solid #e2e2e2',borderRight:'1px solid #e2e2e2'}}>
            {<SideBar 
               users = {allPID}  
               clickPID = { clickPID } 
               messages = {data}
               toggle = {toggleView}
               
               />}
        </div>
        <div className ='col-md-10 col-xs-12' style = {{height:'90vh',borderRight:'1px solid #e2e2e2'}}>
             <div className = 'row'>
                  <div className ={`col-md-6 col-xs-12 p-1 ${hide?'d-none':'' }`} style = {{height:'88vh',borderRight:'1px solid #e2e2e2'}}>
                      <div className='d-flex flex-column'>
                          <MessageHeader PID = {activePID} />
               
                           <div className='p-2' style = {{height:'55vh',overflow:'auto',borderBottom:'1px solid #e2e2e2'}} >     
                                {messages?.length > 0 && (<MessageList dataSource={messages} />) }
                          </div>
                          <ChatInput submit = {testHandler} keyUp = {inputKeyUp} disable = {disable} errMsg = {error}  isProxy = {isProxy}/>       
                      </div>
                  </div>
                  <div className ={`col-md-6 ${hide?'col-md-12':''} col-xs-12 p-0`}>
                       
                       <RenderTask  toggle = {toggleView}/>
                  </div>
             </div>
        </div>
     </Row>
         )
      }
      </>
    
 
    );
}
export default Admin;